"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
var genId = function (i) {
  return function () {
    return ++i;
  };
}(0);
exports.default = genId;
//# sourceMappingURL=genId.js.map


//////////////////
// WEBPACK FOOTER
// ./~/gl-react/lib/genId.js
// module id = 84
// module chunks = 0